export default __webpack_public_path__ + "static/media/promo-icon-bottom-nav-mobile-active.338057ed.webp";